module.exports = __webpack_public_path__ + "static/media/294429.7fd739bd.png";